import React, { useState, useEffect } from "react";
import "./navbar.css";
import Toggle from "../toggle/Toggle";
import { trackNavClick, trackSocialClick } from "../../utils/analytics";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState("home");
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 50;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }

      // Track active section on scroll
      const sections = ["home", "about", "projects", "contact"];
      const scrollPosition = window.scrollY + 100;

      for (const section of sections) {
        const el = document.getElementById(section);
        if (el) {
          const top = el.offsetTop;
          const height = el.offsetHeight;
          if (scrollPosition >= top && scrollPosition < top + height) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [scrolled]);

  const scrollTo = (id) => {
    trackNavClick(id);
    const el = document.getElementById(id);
    if (el) {
      window.scrollTo({
        top: el.offsetTop - 70,
        behavior: "smooth",
      });
      setActiveSection(id);
      setIsOpen(false);
    }
  };

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className={`navbar ${scrolled ? "navbar-scrolled" : ""}`}>
      <div className="navbar-container">
        <div className="navbar-logo" onClick={() => scrollTo("home")}>
          <span>S</span>ezgin<span>.A</span>
        </div>
        <div className={`navbar-menu ${isOpen ? "active" : ""}`}>
          <button
            className={`navbar-item ${activeSection === "home" ? "active" : ""}`}
            onClick={() => scrollTo("home")}
          >
            Home
          </button>
          <button
            className={`navbar-item ${activeSection === "about" ? "active" : ""}`}
            onClick={() => scrollTo("about")}
          >
            About
          </button>
          <button
            className={`navbar-item ${activeSection === "projects" ? "active" : ""}`}
            onClick={() => scrollTo("projects")}
          >
            Projects
          </button>
          <button
            className={`navbar-item ${activeSection === "contact" ? "active" : ""}`}
            onClick={() => scrollTo("contact")}
          >
            Contact
          </button>
          <a
            href="https://www.linkedin.com/in/sezginakgul/"
            target="_blank"
            rel="noreferrer"
            className="navbar-menu-btn"
            onClick={() => {
              trackSocialClick("LinkedIn_Navbar", "https://www.linkedin.com/in/sezginakgul/");
              setIsOpen(false);
            }}
          >
            Connect
          </a>
        </div>
        <div className="navbar-actions">
          <a
            href="https://www.linkedin.com/in/sezginakgul/"
            target="_blank"
            rel="noreferrer"
            className="navbar-btn"
            onClick={() =>
              trackSocialClick("LinkedIn_Navbar", "https://www.linkedin.com/in/sezginakgul/")
            }
          >
            Connect
          </a>
          <Toggle />
          <button
            className={`navbar-hamburger ${isOpen ? "active" : ""}`}
            onClick={toggleMenu}
            aria-label="Toggle navigation menu"
          >
            <span className="bar"></span>
            <span className="bar"></span>
            <span className="bar"></span>
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
